







































import { getCompanyMeasure } from '@/services/api';
import { normalizeAbtestMeasures } from '@/utils/abtestMeasure';
import { AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION } from '@/utils/abtestMetricDisplay';
import { isEnableAttributionWindow, isEnableAuth } from '@/utils/experiment';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({})
export default class ABTestDisplayTableItemDialog extends Vue {

  @Prop()
  visible!:boolean;

  @Prop()
  tableDetail?: any;

  @Watch('visible')
  resetLastMeasure() {
    if (this.visible) {
      this.selectedColumn = this.sanitizeMeasures(this.selectedColumn);
      this.lastSelectedColumn = JSON.parse(JSON.stringify(this.selectedColumn))
    } else {
      this.selectedColumn = this.sanitizeMeasures(JSON.parse(JSON.stringify(this.lastSelectedColumn)))
    }
  }

  get enableAuth() {
    return isEnableAuth();
  }

  get enableAttributionWindow() {
    return isEnableAttributionWindow();
  }

  get showAttributionMetrics() {
    return this.tableDetail?.metricDisplayMode === AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION;
  }

  get columnsMap(): any {
    return {
      'viewCnt': this.$tx('brand.monitor.views', '曝光用户数'),
      'signupCnt': this.$tx('brand.monitor.submits', '提交用户数'),
      'signupRate': this.$tx('form.submitRate', '提交转化率'),
      ...(this.showAttributionMetrics ? {
        'orderGmv': this.$tx('form.ab.sales', '销售额'),
        'orderCntNew': this.$tx('form.ab.orders', '订单数'),
        'orderAtv': this.$tx('form.ab.aov', '客单价')
      } : {}),
      'orderRate': this.enableAttributionWindow ? this.$tx('form.ab.orderRateIp', '下单转化率（IP）') : this.$tx('form.ab.orderRate', '下单转化率'),

      'phoneCnt': this.$tx('form.list.col.phone', '收集手机号总量'),
      'viewRate': this.$tx('form.ab.impressionRate', '曝光率'),
      'orderCnt': this.enableAttributionWindow ? this.$tx('form.ab.orderCntIp', '下单数（IP）') : this.$tx('form.ordersPlaced', '下单数'),

      ...(this.enableAuth ? {
        'loginEmailCnt': this.$tx('form.list.col.loginEmail', '第三方登录收集邮箱总量'),
        'loginSignUpCnt': this.$tx('form.list.col.loginSignup', '第三方登录提交用户数')
      } : {}),
    }
  }

  public selectedColumn:string[] = []
  public lastSelectedColumn = []

  public tableColumnsList: string[] = []
  get selectColumnsList() {
    return this.enableAuth
      ? [
        'viewCnt', 'loginEmailCnt', 'signupCnt', 'loginSignUpCnt', 'signupRate',
        ...(this.showAttributionMetrics ? ['orderGmv', 'orderCntNew', 'orderAtv'] as any : []),
        ...(this.showAttributionMetrics ? [] : ['orderRate']),
        'phoneCnt', 'viewRate',
        ...(this.showAttributionMetrics ? [] : ['orderCnt']),
      ]
      : [
        'viewCnt', 'signupCnt', 'signupRate',
        ...(this.showAttributionMetrics ? ['orderGmv', 'orderCntNew', 'orderAtv'] as any : []),
        ...(this.showAttributionMetrics ? [] : ['orderRate']),
        'phoneCnt', 'viewRate',
        ...(this.showAttributionMetrics ? [] : ['orderCnt']),
      ];
  }

  mounted() {
    // TODO: 需后端修改
    // TODO: 获取当前abtest的measure
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res:any) => {
      const measures = normalizeAbtestMeasures(
        res.data.data.measures || [],
        this.tableDetail?.metricDisplayMode,
        this.showAttributionMetrics
      );
      if(measures?.length){
        this.selectedColumn = this.sanitizeMeasures(measures)
        this.tableColumnsList = this.sanitizeMeasures(measures)
      }else{
        this.selectedColumn = this.tableColumnsList = this.getDefaultMeasures();
      }
    })
  }

  close() {
    this.selectedColumn = this.sanitizeMeasures(this.tableColumnsList)
    this.$emit('update:visible', false);
  }

  sureDataShowVisible() {
    const nextMeasures = this.sanitizeMeasures(this.selectedColumn);
    this.selectedColumn = nextMeasures;
    this.$emit('changeMeasure', nextMeasures);
    setTimeout(() => {
      getCompanyMeasure({
        measureCategory: "FORMABTEST"
      }, true).then((res:any) => {
        const measures = normalizeAbtestMeasures(
          res.data.data.measures || [],
          this.tableDetail?.metricDisplayMode,
          this.showAttributionMetrics
        );
        if(measures?.length){
          this.selectedColumn = this.sanitizeMeasures(measures)
          this.tableColumnsList = this.sanitizeMeasures(measures)
        }else{
          this.selectedColumn = this.tableColumnsList = this.getDefaultMeasures();
        }
      })
    }, 2000);
  }

  getDefaultMeasures() {
    // 默认展示项也要走一次口径清洗，避免存量 null 数据落到错误列集。
    return this.sanitizeMeasures(normalizeAbtestMeasures(
      this.showAttributionMetrics
        ? ['viewCnt', 'signupCnt', 'signupRate', 'orderGmv', 'orderCntNew', 'orderAtv']
        : ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'],
      this.tableDetail?.metricDisplayMode,
      this.showAttributionMetrics
    ));
  }

  sanitizeMeasures(measures: string[] = []) {
    // 只保留当前弹窗允许勾选的列，用户历史保存的旧指标在这里统一收敛。
    return measures.filter((measure) => this.selectColumnsList.includes(measure));
  }

}

